import {
  LocaleCodeToCurrencyCodeMap,
  supportedCurrencyCodes,
} from "@/models/currencyCode"
import type { CurrencyCode } from "@/models/currencyCode"
import type { SupportedLanguageCode } from "@/models/i18n"

import { DEFAULT_CURRENCY } from "../constants"

export type CurrencySymbolPosition = "left" | "right"

interface GetCurrencySymbolOptions {
  includeSpacing: boolean
}

export const getCurrencySymbol = (
  localeCode: string,
  currencyCode: CurrencyCode,
  options: GetCurrencySymbolOptions = {
    includeSpacing: false,
  }
): string => {
  const currencySymbol: string = Intl.NumberFormat(localeCode, {
    style: "currency",
    currency: currencyCode,
  })
    .formatToParts(0)
    .filter((part) => {
      // Include any spacing that is part of the currency symbol display
      if (options.includeSpacing) {
        return part.type === "currency" || part.type === "literal"
      } else {
        return part.type === "currency"
      }
    })
    .map((part) => part.value)
    .join("")

  return currencySymbol
}

export const getCurrencySymbolPosition = (
  localeCode: string,
  currencyCode: CurrencyCode
): CurrencySymbolPosition => {
  const currencyIndex: number = Intl.NumberFormat(localeCode, {
    style: "currency",
    currency: currencyCode,
  })
    .formatToParts(0)
    .findIndex((part) => part.type === "currency")

  return currencyIndex === 0 ? "left" : "right"
}

export const getDefaultCurrencyCode = (locale: string): CurrencyCode => {
  return (
    LocaleCodeToCurrencyCodeMap.get(locale as SupportedLanguageCode) ??
    DEFAULT_CURRENCY
  )
}

export const isSupportedCurrencyCode = (
  currencyCode: CurrencyCode
): boolean => {
  return supportedCurrencyCodes.includes(currencyCode)
}
